import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col, DatePicker, Collapse } from "antd";
import { DownOutlined } from "@ant-design/icons";
import _ from "lodash";
import "./index.scss";
import {
  GET_USER_AGGREGATE_INFO,
  GET_USER_INFO,
  UPDATE_USER_INFO,
} from "reducers/authReducer";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import UploadFileModal from "./UploadFileModal";
import { RootState } from "reducers/rootReducer";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";

const { Panel } = Collapse;

const LocationInput: React.FC<any> = ({
  value = undefined,
  placeholder,
  onChange,
}) => {
  return (
    <div className="datetime-item">
      <GooglePlacesAutocomplete
        selectProps={{
          value,
          onChange: (place: any) => {
            if (place?.value) {
              geocodeByPlaceId(place.value.place_id)
                .then((results) => {
                  if (results[0].geometry) {
                    let location = { 
                      attributes: {
                        ...place,
                        address: place.label
                      },
                      coordinates: {
                        lat: results[0].geometry.location.lat(),
                        long: results[0].geometry.location.lng(),
                      }
                     };
                    onChange(location);
                  }
                })
                .catch((error) => console.error(error));
            }
          },
          isClearable: false,
          placeholder: placeholder,
          styles: {
            input: (provided: any) => ({
              ...provided,
              fontFamily: "Nunito-Regular",
            }),
            control: () => ({
              backgroundColor: "transparent",
              display: "flex",
            }),
            container: (provided, state) => ({
              ...provided,
              width: "100%",
              background: "transparent",
            }),
            placeholder: (provided, state) => ({
              ...provided,
              color: "#000",
              fontSize: 16,
              padding: 8,
            }),
            singleValue: (provided, state) => ({
              ...provided,
              color: "#000",
              fontSize: 16,
              padding: 8,
            }),
          },
        }}
        apiKey={"AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY"}
      />
    </div>
  );
};

const EditBioModal: FC<{ onClose: () => void }> = ({ onClose }) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [firstname, setFirstname] = useState<string>("");
  const [lastname, setLastname] = useState<string>("");
  const [gender, setGender] = useState<string>("Male");
  const [dob, setDOB] = useState<moment.Moment>(moment());
  const [address, setAddress] = useState<any>();
  const { userInfo } = useSelector((state: RootState) => state.auth);
  const [isUploadModalVisible, setIsUploadModalVisible] =
    useState<boolean>(false);
  const { fileToSend } = useSelector((state: RootState) => state.message);
  const [imgData, setImgData] = useState(null);

  useEffect(() => {
    // dispatch(GET_USER_INFO());
    dispatch(GET_USER_AGGREGATE_INFO({ serviceId: undefined }));
  }, []);

  useEffect(() => {
    if (userInfo) {
      setFirstname(userInfo.firstName);
      setLastname(userInfo.lastName);
      setAddress(userInfo.location);
      setGender(userInfo.gender || "Male");
      setDOB(userInfo.dob ? moment(userInfo.dob, "YYYY-MM-DD") : moment());
      setImgData(
        userInfo?.profileImage?.urls?.original?.url ?? "/images/scene.png"
      );
    }
    console.log("userInfo", userInfo);
  }, [userInfo]);

  useEffect(() => {
    if (fileToSend && fileToSend.isBio) {
      console.log("file to send here", fileToSend);

      //   {
      //     "objectId": "1131",
      //     "serviceId": "media-service",
      //     "originalName": "Screenshot 2022-01-13 at 10.06.20 PM.png",
      //     "encoding": "7bit",
      //     "mimeType": "image/png",
      //     "info": {},
      //     "urls": {
      //         "original": {
      //             "url": "https://media-api.dev.beamdev.hu/1131_original.png",
      //             "size": 168315
      //         }
      //     },
      //     "uploadedAt": "2022-06-09T17:56:55.348Z",
      //     "objectStatus": "active",
      //     "isBio": true
      // }

      dispatch(
        UPDATE_USER_INFO({
          ...userInfo,
          profileImage: { urls: fileToSend.urls },
        })
      );
    }
  }, [fileToSend]);

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const handleOk = () => {
    dispatch(
      UPDATE_USER_INFO({
        ...userInfo,
        firstName: firstname,
        lastName: lastname,
        location: address,
        gender,
        dob: moment(dob).format("YYYY-MM-DD"),
      })
    );
    setIsModalVisible(false);
    onClose && onClose();
  };

  return (
    <Modal
      title="Edit Bio"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Row className="text-center mb-5">
        <Col span={24}>
          <img
            src={imgData || "/images/scene.png"}
            className="profileImage cursor-pointer"
            onClick={() => setIsUploadModalVisible(true)}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Input
            value={firstname}
            placeholder="First Name"
            onChange={(e) => setFirstname(e.target.value)}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col span={24}>
          <Input
            value={lastname}
            placeholder="Last Name"
            onChange={(e) => setLastname(e.target.value)}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col span={24}>
          <div className="datetime-item">
            <img src="/images/date.png" />
            <DatePicker
              value={dob}
              placeholder="Date of Birth"
              onChange={(e) => setDOB(e)}
              suffixIcon={<DownOutlined />}
            />
          </div>
        </Col>
      </Row>

      <Row className="d-flex mb-4 mt-3">
        <Col span={12} className="pr-2">
          <Button
            onClick={() => setGender("Female")}
            className={`beam-btn w-full${
              gender === "Female" ? " green-btn cover" : ""
            }`}
          >
            Female
          </Button>
        </Col>
        <Col span={12} className="pl-2">
          <Button
            onClick={() => setGender("Male")}
            className={`beam-btn w-full${
              gender === "Male" ? " green-btn cover" : ""
            }`}
          >
            Male
          </Button>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          {/* <div className="datetime-item prefix-select-wrapper">
            <img src="/images/location.png" />
            <Input
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              className="field-with-image"
              placeholder="Enter Street Address"
            />
          </div> */}

          <LocationInput placeholder="Enter your address" value={(address?.attributes?.value?.place_id) ? address?.attributes: undefined} onChange={(value) => {
            setAddress(value)
          }} />
        </Col>
      </Row>

      <Row className="action-grp mt-4">
        <Col span={14} className="pr-2">
          <Button
            className="beam-btn green-btn cover w-full"
            onClick={handleOk}
          >
            Save
          </Button>
        </Col>
        <Col span={10} className="pl-2">
          <Button
            className="beam-btn orange-btn bordered w-full"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </Col>
      </Row>
      {isUploadModalVisible && (
        <UploadFileModal
          // isModalVisible={isUploadModalVisible}
          // setIsModalVisible={setIsUploadModalVisible}
          onClose={() => setIsUploadModalVisible(false)}
          isBio={true}
        />
      )}
    </Modal>
  );
};

export default EditBioModal;
